<template>
<div class="w-full h-full bg-c2 text-base">
    <NavBar class="bg-c1"/>
    <div class="bg-c3 max-w-screen-lg p-2 sm:p-8 mx-auto"><slot /></div>
    <Footer class="bg-c1"/>
</div>
</template>
